import { render, staticRenderFns } from "./comp-room-share.vue?vue&type=template&id=ff145244&scoped=true&lang=pug&"
import script from "./comp-room-share.vue?vue&type=script&lang=js&"
export * from "./comp-room-share.vue?vue&type=script&lang=js&"
import style0 from "./comp-room-share.vue?vue&type=style&index=0&id=ff145244&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff145244",
  null
  
)

/* custom blocks */
import block0 from "./comp-room-share.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports